import { createListenerMiddleware } from '@reduxjs/toolkit';
import { ACCOUNT_FEATURE, createListenerEffect, selectFeature, selectHasFeatureLoaded } from '@socialive/common';
import {
  getRolesLicensing,
  selectCurrentAccountId,
  setAccountInfo,
  setCurrentAccountId,
  setRolesLicensing,
} from '~/store/accountInfo';
import { selectAuthToken, setAuthToken } from '~/store/env';

export const effect = createListenerEffect(
  'accountInfo/fetchRolesLicensing<Listener>',
  async (action, { dispatch, getState, trigger, take, delay, cancelActiveListeners }) => {
    cancelActiveListeners();
    await delay(100);

    await take((_, state) => selectHasFeatureLoaded(ACCOUNT_FEATURE.USER_ROLES)(state));
    const [, { enabled }] = selectFeature(ACCOUNT_FEATURE.USER_ROLES)(getState());

    if (enabled) {
      await dispatch(getRolesLicensing({ trigger }));
    } else {
      await dispatch(setRolesLicensing({ trigger }));
    }
  }
);

const { startListening, middleware } = createListenerMiddleware();

const actionTypes = new Set([setCurrentAccountId.type, setAccountInfo.type, setAuthToken.type]);

const predicate = (action, state) =>
  actionTypes.has(action.type) && selectAuthToken(state) && selectCurrentAccountId(state);

startListening({
  predicate,
  effect,
});

export default middleware;
